import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import map from 'lodash/map';
import Radium from 'radium';
import QuestionItem from './QuestionItem';

@Radium
class QuizCard extends Component {
  static contextTypes = {
    checkForSubmit: PropTypes.func,
    checkIfSubmittingResponses: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      currentQuestion: 0,
      response: -1,
      selectOption: -1,
      arrowPressed: ''
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.setState({
        currentQuestion: 0,
        response: -1
      });
    }
  }

  getEvaluateStatus = () => {
    const options = this.props.submissionObj.options;
    const answerKey = map(options, 'correct');
    const responseArray = typeof this.state.response === 'string'
      ? this.state.response.split(',')
      : this.props.submission
          && this.props.submission.response.split
          && this.props.submission.response.split(',');

    for (let j = 0; j < answerKey.length; j++) {
      if (answerKey[j] && (responseArray && responseArray.indexOf('' + j)) === -1) {
        return 'FALSE';
      }
      if (answerKey[j] === false && (responseArray && responseArray.indexOf('' + j)) > -1) {
        return 'FALSE';
      }
      if (responseArray && responseArray.indexOf('-1') === 0) {
        return '';
      }
    }
    return 'TRUE';
  };

  emptySubmittedResponse = () => {
    this.setState({ response: -1 });
  };

  getResponse = () => {
    const response = (() => {
      if (this.props.deletingResponse) {
        return '';
      }
      if (typeof this.state.response === 'string') {
        return this.state.response;
      }
      return (this.props.submission && this.props.submission.response) || '';
    })();

    return {
      questionObj: this.props.questionObj,
      emptySubmittedResponse: this.emptySubmittedResponse,
      responseData: {
        questionId: this.props.questionId,
        response,
        answerEvaluation: this.getEvaluateStatus(),
        responseType: this.props.rType,
        isOptional: !this.props.questionObj.contributeToCompleteStatus,
        deletingResponse: this.props.deletingResponse
      },
      callBack: () => {
        this.setState({
          response: -1
        });
      }
    };
  };

  render() {
    return (
      <div style={styles.row}>
        <div style={styles.container}>{this.renderQuiz()}</div>
      </div>
    );
  }

  @autobind
  renderQuiz() {
    const question = this.props.question;
    const isEnrolled = this.props.isEnrolled;

    let submissionData;
    if (isEnrolled && !this.props.preview) {
      submissionData = this.props.submission;
    } else {
      submissionData = [];
    }

    let response = -1;

    if (this.state.response !== -1) {
      response = this.state.response;
    } else {
      response = submissionData && submissionData.response ? submissionData.response : '';
    }

    const submission = {
      response,
      evaluatedAnswer:
        submissionData && submissionData.evaluatedAnswer ? submissionData.evaluatedAnswer : ''
    };
    return (
      <QuestionItem
        question={question}
        submission={submission}
        submissionObj={this.props.submissionObj}
        rType={this.props.rType}
        uploadResponse={this.uploadResponse}
        position={this.props.position}
        isEnrolled={isEnrolled}
        selectOption={this.state.selectOption}
        actualSubmit={this.props.actualSubmit}
        subType={this.props.subType}
      />
    );
  }

  saveOneResponseHandle = () => {
    if (this.props.actualSubmit) {
      return false;
    }
    this.submitTimeout && clearTimeout(this.submitTimeout);
    const getResponseData = this.getResponse();
    this.submitTimeout = setTimeout(() => {
      !this.props.actualSubmit
        && !this.context.checkIfSubmittingResponses()
        && this.props.saveOneResponse(getResponseData);
    }, 1700);

    if (this.props.actualSubmit || this.context.checkIfSubmittingResponses()) {
      this.submitTimeout && clearTimeout(this.submitTimeout);
    }
  };

  @autobind
  uploadResponse(response) {
    this.setState(
      {
        response
      },
      () => {
        this.context.checkForSubmit();
        this.saveOneResponseHandle();
      }
    );
  }
}

const styles = {
  container: {
    flex: 1
    // height: '100%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cursor: {
    cursor: 'pointer'
  },
  enabledView: {
    backgroundColor: 'white'
  },
  disabledView: {
    backgroundColor: 'rgba(255, 255, 255, 0.16)'
  }
};

export default QuizCard;
